export default "__VITE_ASSET__D3kbkxtc__"